import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { AssetId } from '~modules/media-library/model/Asset';
import { ApprovalFormModalPanel } from '~modules/media-library/view/ApprovalForm/ApprovalFormModalPanel';

type ApprovalFormModalProps = {
  isOpen: boolean;
  onClose: () => void;
  assetId: AssetId;
};

export function ApprovalFormModal({ isOpen, onClose, ...PanelProps }: ApprovalFormModalProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-50"
          leave="ease-in duration-200"
          leaveFrom="opacity-50"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </Transition.Child>
        <div className="fixed inset-0 p-8 flex justify-center items-center overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <Dialog.Panel
              as={ApprovalFormModalPanel}
              {...PanelProps}
              onClose={onClose}
              className="transition-all transform"
            />
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
